"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperatorAuthorizationLevels = void 0;
exports.OperatorAuthorizationLevels = {
    BASIC: 'basic',
    ADMIN: 'admin',
    MEGAADMIN: 'megaadmin',
    SUPERADMIN: 'superadmin',
    BROKERDEALER: 'brokerdealer',
};
//# sourceMappingURL=operator-authorization-level.js.map